/**
 * Scrubber backend API base URL.
 * Azure production: Frontend and backend are co-located in the same container,
 * so we use empty string (same origin / relative paths).
 * Local development: Set REACT_APP_SCRUBBER_API_URL=http://localhost:5000
 */
export const SCRUBBER_API_BASE =
  process.env.REACT_APP_SCRUBBER_API_URL || '';
